import * as React from "react";
import { Component } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import AddEvent from "../pages/TrainingEvents/Add/AddEvent";
import ListEvents from "../pages/TrainingEvents/search/ListEvents";
import WorldMapTeam from "../pages/TeamMap/WorldMapTeam";
import AdminHomePage from "../pages/Admin/AdminHomePage";
import PartnerProgram from "../pages/PartnerProgram/PartnerProgram";
import ParseCSVFileDashboard from "../pages/CourseManagement/ExcelParse/ParseCSVFileDashboard";
import PartnerProClubPublic from "../pages/ProClub/public/PartnerProClubPublic";
import PartnerProClubPrivate from "../pages/ProClub/private/PartnerProClubPrivate";
import BootcamppClosed from "../pages/Others/BootcampClosed";
import BootcampFull from "../pages/Others/BootcampFull";
import Homepage from "../pages/PartnerPortal/homepage/Homepage";
import Welcome from "../pages/PartnerPortal/welcomePage/Welcome";
import NewPartnerPortal from "../pages/Others/NewPartnerPortal";
import WelcomeAccenture from "../pages/PartnerPortal/welcomeAccenture/WelcomeAccenture";
import WelcomeWipro from "../pages/PartnerPortal/welcomeWipro/WelcomeWipro";
import WelcomeDXC from "../pages/PartnerPortal/welcomeDXC/WelcomeDXC";
import WelcomeDeloitte from "../pages/PartnerPortal/welcomeDeloitte/WelcomeDeloitte";
import NewPartnerPortalAccounts from "../pages/Others/NewPartnerPortalAccounts";
import Sales from "../pages/PartnerPortal/sales/Sales";
import AppDeveloperSpecialization from "../pages/PartnerPortal/AppDeveloperSpecialization/AppDeveloperSpecialization";
import PartnerSalesEnablement from "../pages/PartnerPortal/PartnerSalesEnablement/PartnerSalesEnablement";
import PartnerSalesSpecialistEnablement from "../pages/PartnerPortal/PartnerSalesSpecialistEnablement/PartnerSalesSpecialistEnablement";
import PartnerSalesEngineerEnablement from "../pages/PartnerPortal/PartnerSalesEngineerEnablement/PartnerSalesEngineerEnablement";
import PartnerDeliveryConsultantEnablement from "../pages/PartnerPortal/PartnerDeliveryConsultantEnablement/PartnerDeliveryConsultantEnablement";
import Enablement from "../pages/PartnerPortal/Enablement/Enablement";
import VippPage from "../pages/PartnerPortal/VippPage/VippPage";
import CloudOpsServicesSpecialization from "../pages/PartnerPortal/CloudOpsServicesSpecialization/CloudOpsServicesSpecialization";
import MigrateServicesSpecialization from "../pages/PartnerPortal/MigrateServicesSpecialization/MigrateServicesSpecialization";
import AssociateBootcamp from "../pages/PartnerPortal/AssociateBootcamp/AssociateBootcamp";
import ProfessionalBootcamp from "../pages/PartnerPortal/ProfessionalBootcamp/ProfessionalBootcamp";
import TechSalesTraining from "../pages/PartnerPortal/TechSalesTraining/TechSalesTraining";
import PortalSupport from "../pages/Others/PortalSupport";
import UnauthorizedAccess from "../pages/Others/UnauthorizedAccess";
import RegistrationFailed from "../pages/Others/RegistrationFailed";
import RegistrationSuccess from "../pages/Others/RegistrationSuccess";
import Marketing from "../pages/Others/Marketing";
import WelcomeKyndryl from "../pages/PartnerPortal/welcomeKyndryl/WelcomeKyndryl";
import HomepageNew from "../pages/PartnerPortal/homepage/HomepageNew";
import PartnerProgramNew from "../pages/PartnerProgram/PartnerProgramNew";
import BootcampOpenSoon from "../pages/Others/BootcampOpenSoon";
import LocatorBanner from "../pages/PartnerPortal/Locator/LocatorBanner";
import HighspotFIles from "../pages/PartnerPortal/Highspot/HighspotFIles";
import CustomSolutions from "../pages/PartnerPortal/CustomSolutions/CustomSolutions";
import WorldMapTeamEdit from "../pages/TeamMap/WorldMapTeamEdit";
import WorldMapTeamRegionEdit from "../pages/TeamMap/WorldMapRegionEdit";
import WelcomeNoPdr from "../pages/PartnerPortal/welcomePage/WelcomeNoPdr";
import WelcomeOnlyPdr from "../pages/PartnerPortal/welcomePage/WelcomeOnlyPdr";
import WelcomeCarousel from "../pages/WelcomeCarousel/WelcomeCarousel";
import VoucherHeader from "../components/VoucherHeader";
import CalendarBlock from "../components/partnerPortalPageComponents/CalendarBlock";
import SubscriptionBlock from "../pages/PartnerPortal/Enablement/SubscriptionBlock";

class AppRoute extends Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
          {/* <Route path="/enablement" component={Enablement} /> */}
          {/* <Route path="/activity-report-form" component={ActivityReportForm} /> */}
          <Route path="/admin/homepage" component={AdminHomePage} />
          {/* <Route path="/course-creation" component={CourseCreation} /> */}
          <Route path="/parse-excel" component={ParseCSVFileDashboard} />
          {/* <Route path="/enrollments/:id" component={EnrollmentManagement} /> */}
          {/* <Route path="/vouchers" component={SendVoucherCodes} /> */}
          <Route path="/add-event/:cluster" component={AddEvent} />
          <Route path="/add-event" component={AddEvent} />
          <Route path="/list-events" component={ListEvents} />
          <Route path="/partner-pro-club" component={PartnerProClubPublic} />
          {/* <Route path="/partner-pro-club-members-only" component={PartnerProClubPrivate} /> */}
          <Route
            path="/world-map/edit/region/:region"
            component={WorldMapTeamRegionEdit}
          />
          <Route path="/world-map/edit/:region" component={WorldMapTeamEdit} />
          <Route path="/world-map/:region" component={WorldMapTeam} />
          <Route path="/partner-program" component={PartnerProgram} />
          <Route path="/custom-solutions" component={CustomSolutions} />
          <Route
            path="/partner-program-new/:partner"
            component={PartnerProgramNew}
          />
          <Route path="/bootcamp-closed" component={BootcamppClosed} />
          <Route path="/bootcamp-full" component={BootcampFull} />
          <Route path="/locator-banner" component={LocatorBanner} />
          <Route path="/bootcamp-open-soon" component={BootcampOpenSoon} />
          <Route path="/unauthorized-access" component={UnauthorizedAccess} />
          <Route path="/registration-failed" component={RegistrationFailed} />
          <Route path="/registration-success" component={RegistrationSuccess} />
          <Route path="/portal-support" component={PortalSupport} />
          <Route path="/homepage" component={Homepage} />
          <Route path="/homepage-new" component={HomepageNew} />
          <Route path="/welcome" component={Welcome} />
          <Route path="/welcome-carousel" component={WelcomeCarousel} />
          <Route path="/welcome-no-pdr" component={WelcomeNoPdr} />
          <Route path="/welcome-only-pdr" component={WelcomeOnlyPdr} />
          <Route path="/welcome-accenture" component={WelcomeAccenture} />
          <Route path="/welcome-deloitte" component={WelcomeDeloitte} />
          <Route path="/welcome-dxc" component={WelcomeDXC} />
          <Route path="/welcome-kyndryl" component={WelcomeKyndryl} />
          <Route path="/welcome-wipro" component={WelcomeWipro} />
          <Route path="/new-partner-portal" component={NewPartnerPortal} />
          <Route
            path="/new-partner-portal-account"
            component={NewPartnerPortalAccounts}
          />
          <Route path="/sales" component={Sales} />
          <Route path="/app-developer" component={AppDeveloperSpecialization} />
          <Route
            path="/partner-sales-enablement"
            component={PartnerSalesEnablement}
          />
          <Route path="/enablement" component={Enablement} />
          <Route path="/associate-bootcamp" component={AssociateBootcamp} />
          <Route
            path="/professional-bootcamp"
            component={ProfessionalBootcamp}
          />
          <Route path="/tech-sales" component={TechSalesTraining} />
          <Route
            path="/partner-sales-specialist-enablement"
            component={PartnerSalesSpecialistEnablement}
          />
          <Route
            path="/partner-sales-engineer-enablement"
            component={PartnerSalesEngineerEnablement}
          />
          <Route
            path="/delivery-consultant-enablement"
            component={PartnerDeliveryConsultantEnablement}
          />
          <Route path="/vipp-program" component={VippPage} />
          <Route
            path="/cloudops-service-specialization"
            component={CloudOpsServicesSpecialization}
          />
          <Route
            path="/migrate-service-specialization"
            component={MigrateServicesSpecialization}
          />
          <Route path="/highspot/files" component={HighspotFIles} />
          <Route path="/marketing" component={Marketing} />
          <Route path="/voucher-header" component={VoucherHeader} />
          <Route path="/calendar-block" component={CalendarBlock} />
          <Route path="/subscription-block" component={SubscriptionBlock} />
          <Redirect to="/not-found" />
        </Switch>
      </React.Fragment>
    );
  }
}

export default AppRoute;
